import { IComponentOptions } from 'angular';
import * as _ from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';

export const CreditMetricsTableTabsComponent: IComponentOptions = {
  template: require('./credit-metrics-table-tabs.html'),
  bindings: {
    cohortsByTerm: '=',
    changeMadeInMetrics: '=',
    creditTableCopy: '=',
    currentSchool: '<',
  },
  controller(ImSchool: ImSchool) {
    this.hasMultipleCohorts = () => {
      return !_.isUndefined(this.cohortsByTerm) && _.isNull(this.cohortsByTerm.allCohorts);
    };

    this.cohortKeyToHumanName = key => {
      if (key === 'allCohorts') return 'All Cohorts';
      else return key.slice(-4);
    };

    this.cohortKeysExceptAllCohorts = () => {
      const upcomingGradDates = ImSchool.getUpcomingGradDates();
      let nextFourGradYears = _.uniq(_.map(upcomingGradDates, ({ year }) => `cohort_${year}`));
      if (nextFourGradYears.length > 4) {
        nextFourGradYears = _.dropRight(nextFourGradYears);
      }
      return nextFourGradYears;
    };
  },
};

angular.module('nv.SchoolMetricsModule').component('creditMetricsTableTabs', CreditMetricsTableTabsComponent);
